import { render, staticRenderFns } from "./modalPieChart.vue?vue&type=template&id=2c5fd2f2&"
import script from "./modalPieChart.vue?vue&type=script&lang=js&"
export * from "./modalPieChart.vue?vue&type=script&lang=js&"
import style0 from "./modalPieChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports